import { DialogContent, Grid, Button, Box, Tabs, Tab, Tooltip, Typography, DialogActions } from '@material-ui/core';
import PrintIcon from '@material-ui/icons/Print';
import React, { useState } from 'react';
import PropTypes from "prop-types";
import { multipleOperationOff, multipleOperationOn, singleOperationOff, singleOperationOn } from '../../../../asset';
import ProductionNPAPieChart from '../charts/ProductionNPAPieChart';
import ProductionTTAPieChart from '../charts/ProductionTTAPieChart';
import { AppPopup } from '../../..';
import ProductionStudyPcsInfo from "../ProductionStudyPcsInfo/ProductionStudyPcsInfo";
import reportsCommonStyles from '../StudyBrowserReports.module.scss'
import styles from './ProductionStudyReport.module.scss'
import { utilFunctions } from '../../../../_helpers';

const ProductionStudyReportTab = (props) => {

    return (
        <React.Fragment>
            <Grid container>
                <Grid container item xs={12} sm={12} md={6} lg={6} className={reportsCommonStyles.summaryInfoContainer}>
                    <Grid
                        container
                        item
                        xs={6}
                        sm={6}
                        direction="column"
                        alignItems="flex-start"
                        justify="center"
                        className={reportsCommonStyles.summaryInfoGroupProd}
                    >
                        <Typography>Total Elapsed Time</Typography>
                        <div>{props.data.totalElapsedTime?.min}<sub>MIN</sub> {props.data.totalElapsedTime?.sec}<sub>SEC</sub></div>
                    </Grid>
                    <Grid
                        container
                        item
                        xs={6}
                        sm={6}
                        direction="column"
                        alignItems="flex-start"
                        justify="center"
                        className={reportsCommonStyles.summaryInfoGroupProd}
                    >
                        <Typography>Total Study</Typography>
                        {props.isSummary ?
                            (
                                <Tooltip title="View PCS Info">
                                    <div style={{ cursor: 'pointer' }} onClick={props.viewReportPcsInfo}>{props.data.totalStudyPCS}<sub>PCS</sub></div>
                                </Tooltip>
                            )
                            :
                            (
                                <div>{props.data.totalStudyPCS}<sub>PCS</sub></div>
                            )
                        }
                    </Grid>
                    {props.isSummary && props.operationSummary ? (<Grid
                        container
                        item
                        xs={12}
                        sm={12}
                        direction="row"
                        alignItems="flex-start"
                        justify="center"
                        className={reportsCommonStyles.summaryInfoGroupProd}
                        >
                            {!!props.operationSummary && props.operationSummary.map((operation, index) => {
                                return (
                                    <div className={reportsCommonStyles.summaryInfoWrapper}>
                                        <span className={reportsCommonStyles.summaryInfoWrapperOperationName}>{operation.operationName}</span>
                                        <span className={reportsCommonStyles.summaryInfoWrapperTime}>
                                        <span>{operation.totalElapsedTime?.min}<sub>MIN</sub></span>
                                        <span>{operation.totalElapsedTime?.sec}<sub>SEC</sub></span>
                                        <span className={reportsCommonStyles.summaryInfoWrapperDevider}></span>
                                        <span>{operation.totalStudyPCS}<sub>PCS</sub></span>
                                        </span>
                                    </div>
                                )
                            })}
                    </Grid>) : ''
                    }
                </Grid>
                <Grid container item xs={12} sm={12} md={6} lg={6} className={reportsCommonStyles.infoContainer}>
                    <Grid container item xs={6} sm={6} className={reportsCommonStyles.infoGroup}>
                        <Grid item xs={4}>EPF</Grid>
                        <Grid item xs={8} className="uppercase bold">{props.data.epf}</Grid>
                    </Grid>
                    <Grid container item xs={6} sm={6} className={reportsCommonStyles.infoGroup}>
                        <Grid item xs={4}>OPERATION MODE</Grid>
                        <Grid item xs={8} className="uppercase bold">
                            {!props.data.isMultiple ?
                                <img src={singleOperationOn} /> :
                                <img src={singleOperationOff} />}
                            {props.data.isMultiple ?
                                <img src={multipleOperationOn} /> :
                                <img src={multipleOperationOff} />}
                        </Grid>
                    </Grid>
                    <Grid container item xs={6} sm={6} className={reportsCommonStyles.infoGroup}>
                        <Grid item xs={4}>TM NAME</Grid>
                        <Grid item xs={8} className="uppercase bold">{props.data.tmName}</Grid>
                    </Grid>
                    <Grid container item xs={6} sm={6} className={reportsCommonStyles.infoGroup}>
                        <Grid item xs={4}>Style</Grid>
                        <Grid item xs={8} className="uppercase bold">{props.data.style}</Grid>
                    </Grid>
                    <Grid container item xs={6} sm={6} className={reportsCommonStyles.infoGroup}>
                        <Grid item xs={4}>Module</Grid>
                        <Grid item xs={8} className="uppercase bold">{props.data.module}</Grid>
                    </Grid>
                    <Grid container item xs={6} sm={6} className={reportsCommonStyles.infoGroup}>
                        <Grid item xs={4}>OPERATION</Grid>
                        <Grid item xs={8} className="uppercase bold">{props.data.operationName}</Grid>
                    </Grid>
                    <Grid container item xs={6} sm={6} className={reportsCommonStyles.infoGroup}>
                        <Grid item xs={4}>CREATED AT</Grid>
                        <Grid item xs={8} className="uppercase bold">{props.data.createdAt}</Grid>
                    </Grid>
                </Grid>
            </Grid>

            <Grid container>
                <Grid item xs={7} sm={7} md={6}>
                    <ProductionTTAPieChart
                        series={props.data?.totalTimeAnalysis?.series || []}
                        labels={props.data?.totalTimeAnalysis?.labels || []}
                        width='100%'
                        height={200} />
                </Grid>
                <Grid item xs={7} sm={7} md={6}>
                    <ProductionNPAPieChart
                        series={props.data?.nonProductiveAnalysis?.series || []}
                        labels={props.data?.nonProductiveAnalysis?.labels || []}
                        width='100%'
                        height={200} />
                </Grid>
            </Grid>

            <Grid container>
                <Grid item xs={3} sm={3} className={`${reportsCommonStyles.dataContainer}`}>
                    <label>Best CT</label>
                    <span>{utilFunctions.formatCycleTimes(props.data.bestCT)}</span>
                </Grid>
                <Grid item xs={3} sm={3} className={`${reportsCommonStyles.dataContainer} ${reportsCommonStyles.lite}`}>
                    <label>Potential PCS</label>
                    <span>{props.data.potentialPCS}<sub>PCS</sub></span>
                </Grid>
                <Grid item xs={3} sm={3} className={`${reportsCommonStyles.dataContainer}`}>
                    <label>Performance</label>
                    <span>{props.data.performance}%</span>
                </Grid>
                <Grid item xs={3} sm={3} className={`${reportsCommonStyles.dataContainer} ${reportsCommonStyles.lite}`}>
                    <label>Fastest CT</label>
                    <span>{props.data.fastestCT !== 0 ? utilFunctions.formatCycleTimes(props.data.fastestCT) : '-'}</span>
                </Grid>
                <Grid item xs={3} sm={3} className={`${reportsCommonStyles.dataContainer} ${reportsCommonStyles.lite}`}>
                    <label>Total Productive Time</label>
                    <span className='textGreen'>{props.data.totalProductiveTime?.min}:{props.data.totalProductiveTime?.sec}</span>
                </Grid>
                <Grid item xs={3} sm={3} className={`${reportsCommonStyles.dataContainer}`}>
                    <label>Total NP Time</label>
                    <span className='textRed'>{props.data.totalNonProductiveTime?.min}:{props.data.totalNonProductiveTime?.sec}</span>
                </Grid>
                <Grid item xs={3} sm={3} className={`${reportsCommonStyles.dataContainer} ${reportsCommonStyles.lite}`}>
                    <label>Watch Error</label>
                    <span>{props.data.watchError}</span>
                </Grid>
                <Grid item xs={3} sm={3} className={`${reportsCommonStyles.dataContainer}`}>
                    <label>Potential Vs Actual</label>
                    <span>{props.data.potentialVsActual}%</span>
                </Grid>
            </Grid>
        </React.Fragment>
    )

}

const TabPanel = (props) => {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`mat-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={0} width="100%">
                    {value === index && children}
                </Box>
            )}
        </div>
    );
}

const ProductionStudyReport = (props) => {
    const activeTabAlter = props.reportData.isMultiple ? 1 : 0;
    const [activeTab, setActiveTab] = React.useState(0);
    const onTabsChange = (event: React.ChangeEvent<{}>, newValue: number) => {
        setActiveTab(newValue)
    }

    const reportPcsInfoInitial = {
        open: false,
        data: []
    }
    const [reportPcsInfoPopup, setReportPcsInfoPopup] = useState(reportPcsInfoInitial)

    const onReportPcsInfoView = () => {
        setReportPcsInfoPopup({
            open: true,
            data: props.reportData.operations
        })
    }
    const toggleReportPcsInfoPopup = (status: boolean, data: any) => {
        setReportPcsInfoPopup({
            open: status,
            data: data
        })
    }


    return (
        <React.Fragment>
            <AppPopup
                scroll={'paper'}
                maxWidth="md"
                fullWidth={true}
                open={reportPcsInfoPopup.open}
                onClose={(status) => toggleReportPcsInfoPopup(status, [])}
                title={"Production Study Operations"}>
                <ProductionStudyPcsInfo data={reportPcsInfoPopup.data || []} />
            </AppPopup>
            <DialogContent>
                <Tabs value={activeTab} onChange={onTabsChange} className="appTabGroup">
                    {props.reportData.isMultiple && <Tab key={0} label={`Summary`} tabIndex={0} />}
                    {!!props.reportData.operations && props.reportData.operations.map((operation, index) => {
                        return (
                            <Tab key={index + activeTabAlter} label={operation.operationName} tabIndex={index + activeTabAlter} />
                        )
                    })}
                </Tabs>
                {props.reportData.isMultiple &&
                    <TabPanel key={0} value={activeTab} index={0} >
                        <ProductionStudyReportTab
                            data={props.reportData?.summary || {}}
                            isSummary={true}
                            viewReportPcsInfo={onReportPcsInfoView}
                            operationSummary={props.reportData.operations}
                        />
                    </TabPanel>
                }
                {!!props.reportData.operations && props.reportData.operations.map((operation, index) => {
                    return (
                        <TabPanel key={index + activeTabAlter} value={activeTab} index={index + activeTabAlter} >
                            <ProductionStudyReportTab data={operation} />
                        </TabPanel>
                    )
                })}
                <div className="isPrintViewVisible">
                    <Grid container className={styles.signatureContainer}>
                        <Grid item xs={3} className={styles.signature}>
                            <Typography className='uppercase textCenter'>TM Sign</Typography>
                        </Grid>
                        <Grid item xs={3} className={styles.signature}>
                            <Typography className='uppercase textCenter'>PE Sign</Typography>
                        </Grid>
                        <Grid item xs={3} className={styles.signature}>
                            <Typography className='uppercase textCenter'>GL Sign</Typography>
                        </Grid>
                    </Grid>
                </div>
            </DialogContent>
            <DialogActions className="isPrintViewHidden">
                <Button variant='contained' color="primary" onClick={() => window.print()}><PrintIcon /> Print Report</Button>
            </DialogActions>
        </React.Fragment>
    )

}
ProductionStudyReport.propTypes = {
    reportData: PropTypes.object.isRequired,
}
ProductionStudyReport.defaultProps = {
    reportData: {
        operations: []
    }
}

export default ProductionStudyReport;